import React, { useEffect, createElement } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2, Check, Home, Calendar, Phone } from 'lucide-react';
interface SuccessScreenProps {
  onReset: () => void;
}
export const SuccessScreen: React.FC<SuccessScreenProps> = ({
  onReset
}) => {
  useEffect(() => {
    // Trigger confetti effect on component mount
    const confetti = () => {
      const canvas = document.createElement('canvas');
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      canvas.style.position = 'fixed';
      canvas.style.top = '0';
      canvas.style.left = '0';
      canvas.style.pointerEvents = 'none';
      canvas.style.zIndex = '100';
      document.body.appendChild(canvas);
      const ctx = canvas.getContext('2d');
      const particles = [];
      const colors = ['#CDA735', '#E3C265', '#FFFFFF', '#B89429'];
      for (let i = 0; i < 150; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: canvas.height + Math.random() * 100,
          size: Math.random() * 8 + 2,
          color: colors[Math.floor(Math.random() * colors.length)],
          speed: Math.random() * 5 + 2,
          angle: Math.random() * Math.PI * 2
        });
      }
      const animate = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        let complete = true;
        particles.forEach(p => {
          p.y -= p.speed;
          p.x += Math.sin(p.angle) * 2;
          ctx.fillStyle = p.color;
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
          ctx.fill();
          if (p.y > -10) complete = false;
        });
        if (complete) {
          document.body.removeChild(canvas);
          return;
        }
        requestAnimationFrame(animate);
      };
      animate();
    };
    confetti();
  }, []);
  return <div className="p-8 md:p-12 text-center" data-id="element-1301">
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iNLk3EmxWWeDcZfjJkYtHX/Veranova_Logo.png" alt="Veranova" className="h-16 mx-auto mb-8 animate-fade-in" data-id="element-1302" />
      <div className="w-20 h-20 bg-gradient-to-r from-[#CDA735] to-[#E3C265] rounded-full flex items-center justify-center mx-auto mb-8 shadow-[0_0_30px_rgba(205,167,53,0.4)] animate-fade-in" data-id="element-1303">
        <CheckCircle2 className="h-10 w-10 text-white" data-id="element-1304" />
      </div>
      <h2 className="text-3xl font-bold text-white mb-4 animate-fade-in" data-id="element-1305">
        Bedankt voor uw aanvraag!
      </h2>
      <p className="text-xl text-white/90 mb-8 max-w-lg mx-auto animate-fade-in" data-id="element-1306">
        We hebben uw configuratie ontvangen en nemen binnen 48 uur contact met u
        op.
      </p>
      <div className="bg-white/10 rounded-lg p-6 max-w-md mx-auto mb-8 text-left animate-fade-in" data-id="element-1307">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-1308">
          Wat kunt u verwachten?
        </h3>
        <ul className="space-y-4" data-id="element-1309">
          <li className="flex items-start" data-id="element-1310">
            <div className="bg-[#CDA735]/20 p-2 rounded-full mr-3 flex-shrink-0" data-id="element-1311">
              <Phone className="h-4 w-4 text-[#CDA735]" data-id="element-1312" />
            </div>
            <div data-id="element-1313">
              <p className="text-white font-medium" data-id="element-1314">Persoonlijk gesprek</p>
              <p className="text-white/70 text-sm" data-id="element-1315">
                Binnen 48 uur neemt één van onze adviseurs contact met u op
              </p>
            </div>
          </li>
          <li className="flex items-start" data-id="element-1316">
            <div className="bg-[#CDA735]/20 p-2 rounded-full mr-3 flex-shrink-0" data-id="element-1317">
              <Calendar className="h-4 w-4 text-[#CDA735]" data-id="element-1318" />
            </div>
            <div data-id="element-1319">
              <p className="text-white font-medium" data-id="element-1320">Adviesgesprek</p>
              <p className="text-white/70 text-sm" data-id="element-1321">
                We plannen een vrijblijvend adviesgesprek bij u thuis
              </p>
            </div>
          </li>
          <li className="flex items-start" data-id="element-1322">
            <div className="bg-[#CDA735]/20 p-2 rounded-full mr-3 flex-shrink-0" data-id="element-1323">
              <Check className="h-4 w-4 text-[#CDA735]" data-id="element-1324" />
            </div>
            <div data-id="element-1325">
              <p className="text-white font-medium" data-id="element-1326">Gedetailleerde offerte</p>
              <p className="text-white/70 text-sm" data-id="element-1327">
                U ontvangt een persoonlijke offerte op maat
              </p>
            </div>
          </li>
        </ul>
        <div className="mt-4 pt-4 border-t border-white/20" data-id="element-1328">
          <p className="text-white/90 text-sm" data-id="element-1329">
            <strong data-id="element-1330">Let op:</strong> Verdere details over uw project zullen
            telefonisch met u worden besproken tijdens het eerste contact.
          </p>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row justify-center gap-4 animate-fade-in" data-id="element-1331">
        <Link to="/" className="px-6 py-3 bg-white/10 hover:bg-white/20 text-white rounded-md transition-colors flex items-center justify-center" data-id="element-1332">
          <Home className="mr-2 h-5 w-5" data-id="element-1333" />
          <span data-id="element-1334">Terug naar home</span>
        </Link>
        <button onClick={onReset} className="px-6 py-3 bg-[#CDA735] hover:bg-[#B89429] text-white rounded-md transition-colors flex items-center justify-center shadow-md hover:shadow-lg" data-id="element-1335">
          <span data-id="element-1336">Nieuwe configuratie</span>
          <ArrowRight className="ml-2 h-5 w-5" data-id="element-1337" />
        </button>
      </div>
    </div>;
};